import styled from "styled-components";
import { Modal } from "antd";
import { PrimaryButtonComponent } from "../../../../../../CommonComponents/commonStyles";

export const DisplayContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const SectionHeading = styled.div`
  font-family: ${(props) => props.theme.fontFamily.BerkeleyStdBold};
  font-size: ${(props) => props.theme.fontSize.h4};
  font-style: normal;
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: 1.17;
  letter-spacing: ${(props) => props.theme.letterSpacing.normal};
  color: ${(props) => props.theme.fontColors.headingColor};
`;

export const ButtonContainer = styled.div`
  text-align: center;
  width: 200px;
`;

export const CustomModal = styled(Modal)`
  .ant-modal-footer {
    display: flex;
    justify-content: center;
    text-align: center;
    border-top: none;
  }
  .ant-modal-body {
    padding: 12px 0px 10px 0px; 
    .ant-table-wrapper {
      border-top: 1px solid #b6bdbd;
    }
  }
  .ant-modal-content {
    border-radius: 0px;
    padding: 30px;
    @media only screen and (max-width: 576px) {
      padding: 30px 20px;
    }

    @media only screen and (max-width: 991px) {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 991px) {
    width: 98% !important;
    height: 97vh;
    top: 10px;
    padding: 0;
  }
  @media only screen and (max-width: 576px) {
    top: 0px !important;
  }
`;
export const LoadMoreButton = styled(PrimaryButtonComponent)`
  margin: 30px auto;
  width: 300px;
  @media only screen and (max-width: 991px) {
    font-size: ${(props) => props.theme.fontSize.primary};
  }
`;

export const RemovePrimaryButtonComponent = styled(PrimaryButtonComponent)`
  margin-bottom: 10px !important;
`;

export const EndResult = styled.div`
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  font-size: ${(props) => props.theme.fontSize.primary};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${(props) => props.theme.fontStretch.normal};
  line-height: ${(props) => props.theme.lineHeight.primary};
  letter-spacing: ${(props) => props.theme.letterSpacing.zero};
  color: ${(props) => props.theme.fontColors.textColor};
  padding-top: 2.5rem;
`;
